import React from 'react';
import PropTypes from 'prop-types';
import {Button, Flex, Text} from 'rebass'
import {Backdrop, InlineBlock, Overlay} from "reakit";
import styled from "styled-components";

const StyledOverlay = styled(Overlay)`
	min-width: 150px;
	min-height: 110px;
	@media(max-width: 700px){
	min-width: 80vw;
	}
`

const ConfirmCheckIn = props => {
	const { toggle } = props;

	return (
		<Overlay.Container>
			{overlay => (
				<InlineBlock>
					<Backdrop fade use={Overlay.Hide} {...overlay} visible={true} onClick={toggle} zIndex={1100}/>
					<StyledOverlay fade slide {...overlay} visible={true} zIndex={1200} >
						<Text mb={3} fontWeight={'bolder'}>Single click to check in, double click to access student profile.</Text>
						<Flex flexDirection={'row'}>
							<Button variant={'approve'} p={1} m={'auto'} bg={'green'} onClick={() => {
								toggle()
							}}>OK</Button>
						</Flex>
						
					</StyledOverlay>
				</InlineBlock>
			)}
		</Overlay.Container>
	);
};

ConfirmCheckIn.propTypes = {
	toggle: PropTypes.func,
	visible: PropTypes.bool,
	noButton: PropTypes.bool
};

ConfirmCheckIn.defaultProps = {
	visible: true,
	noButton: false
};

export default ConfirmCheckIn;
